import React from "react";
import Link from "next/link";
import FadeInAnimation from "../Common/FadeInAnimation";
import { BiChevronRight, BiBuildingHouse, BiSearchAlt, BiLogoVisualStudio, BiLogoChrome } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const KiWeitereDienstleistungen = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t('ki_weitereDienstleistungen_title')}</span>
            <h2>{t('ki_weitereDienstleistungen_description')}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">
                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiBuildingHouse />
                      </div>
                      <h3>{t('ki_weitereDienstleistungen_title2')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('ki_weitereDienstleistungen_description2') }} />
                      <span className="features-box-action">{t('ki_weitereDienstleistungen_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildingHouse />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/business-analytics" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiSearchAlt />
                      </div>
                      <h3>{t('ki_weitereDienstleistungen_title3')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('ki_weitereDienstleistungen_description3') }} />
                      <span className="features-box-action">{t('ki_weitereDienstleistungen_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiSearchAlt />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/software-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoVisualStudio />
                      </div>
                      <h3>{t('ki_weitereDienstleistungen_title4')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('ki_weitereDienstleistungen_description4') }} />
                      <span className="features-box-action">{t('ki_weitereDienstleistungen_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoVisualStudio />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoChrome />
                      </div>
                      <h3>{t('ki_weitereDienstleistungen_title5')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('ki_weitereDienstleistungen_description5') }} />
                      <span className="features-box-action">{t('ki_weitereDienstleistungen_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoChrome />
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

            </div>
          </FadeInAnimation >

        </div >
      </div >
    </>
  );
};

export default KiWeitereDienstleistungen;
